import { NavigationRegions } from '@trustedshops/tswp-carrier-b2b-contracts';
import { AbstractPersistentEvent } from '@trustedshops/tswp-core-common';
import { NavigationRegionConfiguration } from '@trustedshops/tswp-core-ui';

export const secondaryNavigationRegion: NavigationRegionConfiguration = {
  name: NavigationRegions.SecondaryMenu,
  animationDurations: {
    expand: 0,
    collapse: 0
  },
  initialState: {
    collapsed: new AbstractPersistentEvent(false)
  }
};
